class EasyReturnsTab{
  constructor(container){
    this.container = container
    this.titles = this.container.querySelectorAll(".tab-title")
    this.tab_container = this.container.querySelector(".tab-container")
    this.tabs = this.container.querySelectorAll(".tab")
    console.log(parseInt(window.getComputedStyle(this.tabs[0]).height))
    this.tab_container.style.height = (parseInt(window.getComputedStyle(this.tabs[0]).height) + 250).toString()+"px";
    this.active_tab_index = 0
    this.titles.forEach(element => {
      element.addEventListener('click',()=>this.item_clicked(element.getAttribute('item-index')))
    });
    this.opened_answer_index = -1
    this.questions = this.container.querySelectorAll("question")
    this.arrows = []
    this.questions.forEach((question,index)=>{
      let arrow = document.createElement("i");
      arrow.classList.add("fa-solid")
      arrow.classList.add("fa-chevron-down")
      arrow.classList.add("question-arrow")
      question.appendChild(arrow)
      question.setAttribute("item-index",index)
      question.addEventListener('click',()=>this.question_clicked(index))
      this.arrows.push(arrow)
    })
    this.answers = this.container.querySelectorAll("answer")
    this.answers.forEach((answer,index)=>{
      answer.setAttribute("item-index",index)
    })
  }
  question_clicked(index)
  {
    if(!this.questions[index].classList.contains("expanded"))
    {
      if(this.opened_answer_index!=-1)
      {
        this.answers[this.opened_answer_index].classList.remove("active")
        this.arrows[this.opened_answer_index].classList.remove("up")
        this.questions[this.opened_answer_index].classList.remove("expanded")
      }
      this.answers[index].classList.add("active")
      this.opened_answer_index = index
      this.questions[index].classList.add("expanded")
      this.arrows[index].classList.add("up")
    }
    else{
      this.answers[index].classList.remove("active")
      this.questions[index].classList.remove("expanded")
      this.arrows[index].classList.remove("up")
      this.opened_answer_index = -1
    }
  }
  item_clicked(index)
  {
    this.titles[this.active_tab_index].classList.remove("active")
    this.titles[index-1].classList.add("active")
    this.tabs[this.active_tab_index].classList.remove("active")
    this.tabs[index-1].classList.add("active")
    this.tab_container.style.height = (parseInt(window.getComputedStyle(this.tabs[index-1]).height) + 250).toString()+"px";
    this.active_tab_index=index-1
  }
}
